import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=f51df1be&scoped=true"
import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Editor.vue?vue&type=style&index=0&id=f51df1be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51df1be",
  null
  
)

export default component.exports